<template>
  <div class="wrap">
    <div class="h-top">
      <div
        class="h-top-contnet"
        v-lazy-container="{
          selector: 'img',
          error: require('../assets/images/750-100.png'),
          loading: require('../assets/images/750-100.png')
        }"
      >
        <img class="logo" :data-src="logo" />
        <div class="llt">
          <div ref="swiper3" class="swiper-container" style="height: 100%">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in lunbo"
                :key="index"
              >
                <img
                  @click="isIos() ? openUrl(item.iosUrl) : openUrl(item.andUrl)"
                  :src="item.image"
                  :data-src="item.image"
                  :data-top="item.image"
                  alt
                  style="height: 100%"
                />
                <!-- @click="xfbdownloadFun()"  -->
                <div
                  @click="isIos() ? openUrl(item.iosUrl) : openUrl(item.andUrl)"
                  class="h-top-item"
                >
                  立即下载
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fl-nav">
      <div id="navtag" class="fl-nav-cell" :style="{ height: heightVal }">
        <ul>
          <li
            v-for="(item, index) in tagsList"
            :class="{ tagactive: tagIndex == index }"
            :key="index"
            @click="jumper(index)"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
      <div class="icon-box" @click="changeFun()">
        <van-icon :name="iconName" />
      </div>
      <div class="van-tabs-box" v-show="!tagbool">
        <ul class="tag-view">
          <li
            v-for="(item, index) in tagsList"
            :key="index"
            @click="tagChange(index)"
            class="tag-view-cell"
            :class="{ tagactive: tagIndex == index }"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
    </div>
    <div class="mod_hotgame">
      <div ref="swiper1" :options="swiperOption1" class="swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in tagsList"
            :key="index"
          >
            <ul>
              <li
                v-for="(item, index1) in item.list"
                @click="hotliCheng(index, index1)"
                :key="index1"
                v-lazy-container="{
                  selector: 'img',
                  error: require('../assets/images/icon.png'),
                  loading: require('../assets/images/icon.png')
                }"
              >
                <img :data-src="item.imgsrc" />
                <p>{{ item.name }}</p>
                <a class="down-pc" alt="pc">下载</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div style="height:2px;" class="line-through"></div>
    <div class>
      <div ref="swiper2" :options="swiperOption" class="swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in lbList"
            :key="index"
          >
            <img
              @click="slideCheng(index)"
              class="Slide-img"
              :src="item.imgsrc"
              alt
            />
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div style="height:2px;" class="line-through"></div>
    <div class>
      <ul class="section-3">
        <li
          class="section-3-li clearfix"
          v-for="(item, index) in generalList"
          @click="appliCheng(index)"
          :key="index"
        >
          <div
            class="img-div"
            v-lazy-container="{
              selector: 'img',
              error: require('../assets/images/icon.png'),
              loading: require('../assets/images/icon.png')
            }"
          >
            <img :data-src="item.imgsrc" alt="logo" />
          </div>
          <div class="middle-word">
            <div class="middle-word-h2">{{ item.name }}</div>
            <div class="sub-title">
              <p>{{ item.dec }}</p>
            </div>
            <p class="download-number">下载次数：{{ item.downNum }}次</p>
          </div>
          <a class="down" alt="pc">下载</a>
        </li>
      </ul>
    </div>
    <div v-show="zzboxBool" class="xfb-zz-content">
      <div class="xfb-zz-content-box">
        <div @click="closeFun()" class="close">关闭</div>
        <div ref="qrCodeUrl" class="img-box"></div>
        <p>扫一扫下载榴莲视频APP</p>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import Swiper from "swiper";
import $ from "jquery";
export default {
  name: "index",
  data() {
    return {
      tagbool: true,
      zzboxBool: false,
      Width: "",
      liwidth: "",
      hotSwiper: "",
      lbList: [],
      liatApp: [],
      hotList: [],
      heightVal: "45px",
      xfbAppURL: "",
      xfbURL: "",
      tagIndex: 0,
      tagsList: [],
      generalList: [],
      xfbApp: "",
      logo: "",
      iconName: "arrow-down",
      logoList: [],
      ggimg: [],
      swiperOption: {
        pagination: ".swiper-pagination",
        paginationType: "bullets",
        autoplay: 4000,
        loop: true
      },
      swiperOption1: {
        paginationType: "bullets",
        autoplay: false,
        loop: true
      },
      queryData: {
        aid: "",
        type: ""
      },
      lunbo: window.lunbo.image
    };
  },
  created() {
    this.xfbURL = xfbUrl;
    this.logo = logoUrl;
    this.tagsList = tags;
    this.xfbAppURL = xfbAppUrl;
    this.lbList = lunboList;
    // this.hotList = this.tagsList[0].list;
    this.Width = window.screen.availWidth;
    this.lbList.sort(function() {
      return Math.random() > 0.5 ? -1 : 1;
    });
    this.liatApp = dataApp;
    this.generalList = dataApp;
  },
  mounted() {
    new Swiper(this.$refs.swiper2, {
      pagination: {
        el: ".swiper-pagination"
      }, //坑
      paginationType: "bullets",
      autoplay: {
        disableOnInteraction: false, //增加此属性即可
        delay: 4000
      },
      autoHeight: true,
      speed: 500,
      autoplayDisableOnInteraction: true,
      direction: "horizontal",
      observeSlideChildren: true,
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: false, //修改swiper的父元素时，自动初始化swiper
      onSlideChangeEnd: function(swiper) {
        swiper.update();
        swiperV.startAutoplay();
        swiperV.reLoop();
      }
    });
    this.hotSlideFun();
    this.creatQrCode();

    new Swiper(this.$refs.swiper3, window.lunbo.config);
  },
  computed: {
    showSwiper() {
      return this.lbList.length;
    }
  },
  methods: {
    //创建swiper列表
    hotSlideFun() {
      var _this = this;
      _this.hotSwiper = new Swiper(this.$refs.swiper1, {
        paginationType: "bullets",
        autoplay: false,
        speed: 500,
        autoplayDisableOnInteraction: true,
        direction: "horizontal",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        observeSlideChildren: true,
        on: {
          slideChangeTransitionStart: function() {
            _this.jumper(this.realIndex);
            _this.tagChange(this.realIndex);
          },
          touchMove: function(event) {
            $("#navtag li").each(function(i) {
              if (i == _this.tagIndex) {
                _this.liwidth = this.offsetWidth;
              }
            });
            //你的事件
          },
          TouchEnd: function(swiper) {
            $("#navtag li").each(function(i) {
              alert(_this.tagIndex);
              if (i == _this.tagIndex) {
                $(this).width(_this.liwidth);
              }
            });
          },
          touchEnd: function(event) {
            console.log(event);
            _this.getDecoration();
          },
          slidePrevTransitionEnd: function() {
            console.log("pre1");
          },
          slideNextTransitionEnd: function() {
            console.log("next1");
          }
        }
      });
    },
    getDecoration() {
      console.log(this.hotSwiper.swipeDirection);
    },
    //標簽按鈕點擊事件
    jumper(index) {
      var scrollPosition = $("#navtag li")[index].offsetLeft;
      var liWidth = $("#navtag li")[index].offsetWidth;
      var left = scrollPosition - (this.Width - liWidth) / 2;
      $("#navtag").animate({ scrollLeft: left }, 100);
      this.tagIndex = index;
      this.hotSwiper.slideTo(this.tagIndex);
    },
    //更多切换按钮
    changeFun() {
      if (this.iconName == "arrow-up") {
        this.iconName = "arrow-down";
        this.tagbool = true;
        this.heightVal = "45px";
      } else {
        this.iconName = "arrow-up";
        this.tagbool = false;
        if (this.tagsList.length % 5 == 0) {
          this.heightVal = parseInt(this.tagsList.length / 5) * 45 + "px";
        } else {
          this.heightVal = (parseInt(this.tagsList.length / 5) + 1) * 45 + "px";
        }
      }
    },
    //更多Item点击事件
    tagChange(index) {
      this.tagIndex = index;
      this.jumper(this.tagIndex);
      this.hotSwiper.slideTo(this.tagIndex);
    },
    //生成二维码
    creatQrCode() {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.xfbURL,
        width: 100,
        height: 100,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    //轮播图点击方法
    slideCheng(index) {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        //苹果URL
        window.open(this.lbList[index].iosUrl, "_blank");
      } else if (/(Android)/i.test(navigator.userAgent)) {
        //安卓URL
        window.open(this.lbList[index].andUrl, "_blank");
      } else {
        //pc端
        this.zzboxBool = true;
      }
    },
    //app点击方法
    appliCheng(index) {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        //苹果URL
        window.open(this.generalList[index].iosUrl, "_blank");
      } else if (/(Android)/i.test(navigator.userAgent)) {
        //安卓URL
        window.open(this.generalList[index].andUrl, "_blank");
      } else {
        //pc端
        this.zzboxBool = true;
      }
    },
    //热门app点击方法
    hotliCheng(cell, row) {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        //苹果URL
        window.open(this.tagsList[cell].list[row].iosUrl, "_blank");
      } else if (/(Android)/i.test(navigator.userAgent)) {
        //安卓URL
        window.open(this.tagsList[cell].list[row].andUrl, "_blank");
      } else {
        //pc端
        this.zzboxBool = true;
      }
    },
    //立即下载点击方法
    xfbdownloadFun() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        window.location.href = this.xfbAppURL.iosUrl;
      } else if (/(Android)/i.test(navigator.userAgent)) {
        window.location.href = this.xfbAppURL.andUrl;
      } else {
        //pc端
        this.zzboxBool = true;
      }
    },
    isIos() {
      return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    },
    openUrl(url) {
      window.location.href = url;
    },
    //关闭遮罩层
    closeFun() {
      this.zzboxBool = false;
    }
  }
};
</script>
<style>
@import "../../node_modules/swiper/css/swiper.css";
@import "vant/lib/index.css";

.swiper-slide {
  height: 1px;
} /* 随意指定一个height值即可 */
.swiper-slide-active {
  height: auto !important;
}
.fl-nav {
  position: relative;
  width: 100%;
  margin: 0px 0px;
  padding-right: 40px;
  box-sizing: border-box;
  border-bottom: 1px solid #e4e4e4;
}
.fl-nav-cell {
  text-align: left;
  align-items: center;
  width: 100%;
  display: inline-block;
  white-space: nowrap;
  display: flex;
  height: 44px;
  overflow-x: scroll;
}

.fl-nav-cell::-webkit-scrollbar {
  height: 0px;
}
.fl-nav-cell ul {
  padding: 0 0px 0 5px;
  box-sizing: border-box;
  margin: 0 auto;
  list-style: none;
  width: 100%;
  display: flex;
}
.fl-nav-cell ul li {
  padding: 0 15px;
  box-sizing: border-box;
  text-align: center;
  position: relative;
  line-height: 44px;
  min-width: 35px;
  display: inline-block;
  font-size: 14px;
  color: #000000;
  flex: 1;
}
.fl-nav-cell-box {
  text-align: left;
  height: 60px;
  width: 110px;
  padding: 10px 10px;
  border-radius: 2px;
  box-sizing: border-box;
}
.fl-nav-cell-box img {
  width: 18px;
  height: 18px;
}
.fl-nav-cell-box-p {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0;
  height: 20px;
  letter-spacing: 1px;
  text-align: left;
  overflow: hidden; /*超出部分隱藏*/
  text-overflow: ellipsis; /*超出部分顯示省略號*/
  white-space: nowrap; /*規定段落中的文本不進行換行 */
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
}
.fl-nav-cell-box-row {
  width: 100%;
  height: 20px;
  display: inline-flex;
}
.fl-nav-cell-box-row-label {
  width: 72px;
  overflow: hidden; /*超出部分隱藏*/
  text-overflow: ellipsis; /*超出部分顯示省略號*/
  white-space: nowrap; /*規定段落中的文本不進行換行 */
  font-size: 15px;
  letter-spacing: 2px;
  padding: 0 0 0 2px;
  box-sizing: border-box;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 18px;
  text-align: left;
}

/*  */
.van-tabs__line {
  position: absolute;
  bottom: 15px;
  left: 0;
  z-index: 1;
  height: 3px;
  background-color: #fff;
  border-radius: 3px;
}
.van-icon {
  font-size: 20px;
}
.tag-view {
  width: 100%;
  display: inline-flex;
  flex-wrap: wrap;
  position: relative;
}
.tag-view .tag-view-cell {
  min-width: 20%;
  margin: 0 0;
  position: relative;
  box-sizing: border-box;
  padding: 0 5px;
  color: #000;
  font-size: 14px;
  line-height: 44px;
  text-align: center;
}
.tagactive {
  background: linear-gradient(left bottom, #20e0ff, #54a8ff);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent !important;
}
.tagactive::after {
  width: 50%;
  position: absolute;
  content: "";
  bottom: 0px;
  left: 50%;
  z-index: 99;
  transform: translateX(-50%);
  height: 3px;
  border-radius: 1.5px;
  background: -webkit-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -o-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -mos-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -moz-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(
    270deg,
    rgba(84, 168, 255, 1),
    rgba(32, 224, 255, 1)
  );
}
.Slide-img {
  width: 100%;
  vertical-align: middle;
  object-fit: cover;
}
@media only screen and (min-width: 100px) and (max-width: 500px) {
  .Slide-img {
    height: 45.3vw;
  }
}
.swiper-pagination-bullet-active {
  width: 16px !important;
  background: #fff !important;
  border-radius: 4px !important;
}
.swiper-pagination-bullet {
  background-color: #999;
  opacity: 1;
}
.wh_show_bgcolor {
  background: #fff !important;
}

@media only screen and (min-width: 501px) {
  .wrap {
    background: #fff;
    max-width: 500px;
    margin: 0 auto;
    overflow: hidden;
    min-width: 320px;
  }
}
@media only screen and (max-width: 500px) {
  .wrap {
    background: #fff;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    min-width: 320px;
  }
}
.h-top {
  width: 100%;
  /*height: 50px;*/
  /* border-bottom: 2px solid rgba(240, 240, 240, 1); */
  position: relative;
  /* background: -webkit-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -o-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -mos-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -moz-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(
    270deg,
    rgba(84, 168, 255, 1),
    rgba(32, 224, 255, 1)
  ); */
}

.h-top-contnet {
  position: relative;
  width: 100%;
}

.h-top-contnet .logo {
  width: 100%;
  vertical-align: bottom;
}

.h-top-contnet .title {
  height: 36px;
  margin-top: 2px;
  margin-left: 1px;
}

.h-top-item {
  width: 70px;
  position: absolute;
  background-color: #fff;
  height: 30px;
  border-radius: 15px;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  line-height: 30px;
  font-size: 13px;
  color: rgba(78, 175, 255, 1);
  z-index: 99;
  visibility: hidden;
}
.swiper-slide-active .h-top-item {
  visibility: visible;
}
/*  */
.mod_hotgame {
  overflow: hidden;
  padding-bottom: 15px;
}
.mod-header {
  border-bottom: 1px solid #e4e4e4;
  position: relative;
}

.van-tabs-box {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 999;
  right: 40px;
  background-color: #fff;
  box-sizing: border-box;
}
.icon-box {
  width: 40px;
  position: absolute;
  top: 0px;
  padding: 11px 10px;
  box-sizing: border-box;
  height: 44px;
  right: 0px;
}
.mod-header-h3 {
  float: left;
  font-size: 17px;
  color: #333;
  font-weight: bold;
  height: 43px;
  padding: 0 1%;
  position: relative;
}
.mod-header-h3::after {
  float: left;
  font-size: 17px;
  color: #333;
  font-weight: bold;
  height: 43px;
  padding: 0 1%;
  position: relative;
}
.mod-header-h3:after {
  position: absolute;
  bottom: -4px;
  height: 3px;
  width: 100%;
  content: "";
  background: -webkit-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -o-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -mos-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -moz-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(
    270deg,
    rgba(84, 168, 255, 1),
    rgba(32, 224, 255, 1)
  );
  border-radius: 1.5px;
  left: 0px;
  right: 0px;
}
.mod-header .more {
  line-height: 46px;
  font-size: 12px;
  color: #999999;
  display: block;
  float: right;
}
a {
  text-decoration: none;
}
.mod_hotgame-ul {
  width: 100%;
  position: relative;
  list-style: none;
  margin: 0 0;
  padding: 0 0;
}
.mod_hotgame li {
  float: left;
  width: 16%;
  margin: 10px 4.5% 0;
}
.mod_hotgame li img {
  display: block;
  width: 100%;
  border-radius: 13px;
  margin: 0 auto;
  overflow: hidden;
}
.mod_hotgame li p {
  font-size: 14px;
  width: 100%;
  height: 32px;
  line-height: 32px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mod_hotgame li .down-anz {
  color: #fff;
  background: -webkit-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -o-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -mos-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -moz-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(
    270deg,
    rgba(84, 168, 255, 1),
    rgba(32, 224, 255, 1)
  );
  box-shadow: 0px 0px 10px 4px rgba(59, 195, 255, 0.2);
  text-align: center;
  margin: 0 auto;
  height: 25px;
  line-height: 25px;
  display: block;
  font-size: 13px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}
.section-3 {
  padding: 0 15px 15px 15px;
  list-style: none;
  box-sizing: border-box;
}

.section-3-li {
  width: 100%;
  position: relative;
  height: 107.5px;
  box-sizing: border-box;
  padding-top: 13.5px;
  border-bottom: 1px solid rgb(239, 239, 239);
}
.section-3 .section-3-li:last-child {
  border-bottom: 0px solid rgb(239, 239, 239);
}

.section-3-li .img-div {
  float: left;
  width: 80px;
  height: 80px;
  background-color: rgb(239, 239, 239);
  border: 1px solid rgb(239, 239, 239);
  border-radius: 8px;
  overflow: hidden;
}

.section-3-li .img-div img {
  width: 100%;
  height: 100%;
}
.middle-word {
  float: left;
  text-align: left;
  margin-left: 9px;
  width: 160px;
}

.middle-word-h2 {
  font-size: 15px;
  font-weight: bold;
  line-height: 15px;
  color: rgba(51, 51, 51, 1);
}

.middle-word .sub-title {
  position: relative;
  width: 100%;
  margin: 6px 0 0 0;
  color: rgba(81, 171, 255, 1);
  height: 40px;
}
.middle-word .sub-title p {
  width: 100%;
  position: absolute;
  left: 0px;
  margin: 0 0;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 13px;
  color: rgba(81, 171, 255, 1);
  line-height: 20px;
}

.middle-word .download-number {
  margin-top: 6.5px;
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
  line-height: 12px;
}

.clearfix::after {
  content: " ";
  height: 0;
  display: block;
  clear: both;
}

.download-btn-main .download-btn {
  width: 79.5px;
  height: 26.5px;
  box-sizing: border-box;
  border: 2px solid rgb(84, 176, 44);
  border-radius: 5px;
  font-size: 13px;
  color: rgb(84, 176, 44);
  text-align: center;
  line-height: 22px;
  cursor: pointer;
}

.download-btn-main .margin-top-attr {
  margin-top: 25px;
}

.download-btn {
  float: right;
}

a {
  text-decoration: none;
}

.line-through {
  width: 100%;
  height: 4px;
  background: rgba(240, 240, 240, 1);
  position: relative;
}

.section-3-li .down-anz {
  color: #fff;
  background: -webkit-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -o-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -mos-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -moz-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(
    270deg,
    rgba(84, 168, 255, 1),
    rgba(32, 224, 255, 1)
  );
  box-shadow: 0px 0px 10px 4px rgba(59, 195, 255, 0.2);
  text-align: center;
  width: 17%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0px;
  height: 25px;
  line-height: 25px;
  display: block;
  font-size: 13px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.section-3-li .down {
  color: #fff;
  background: -webkit-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -o-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -mos-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -moz-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(
    270deg,
    rgba(84, 168, 255, 1),
    rgba(32, 224, 255, 1)
  );
  box-shadow: 0px 0px 10px 4px rgba(59, 195, 255, 0.2);
  text-align: center;
  width: 18%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0px;
  height: 28px;
  line-height: 28px;
  display: block;
  font-size: 13px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.section-3-li .down-pc {
  color: #fff;
  background: -webkit-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -o-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -mos-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -moz-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(
    270deg,
    rgba(84, 168, 255, 1),
    rgba(32, 224, 255, 1)
  );
  box-shadow: 0px 0px 10px 4px rgba(59, 195, 255, 0.2);
  text-align: center;
  width: 17%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0px;
  height: 25px;
  line-height: 25px;
  display: block;
  font-size: 13px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}
/**/

.mod_hotgame li .down-anz {
  color: #fff;
  background: -webkit-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -o-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -mos-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -moz-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(
    270deg,
    rgba(84, 168, 255, 1),
    rgba(32, 224, 255, 1)
  );
  box-shadow: 0px 0px 10px 4px rgba(59, 195, 255, 0.2);
  text-align: center;
  margin: 0 auto;
  height: 25px;
  line-height: 25px;
  display: block;
  font-size: 13px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.mod_hotgame li .down-ios {
  color: #fff;
  background: -webkit-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -o-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -mos-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -moz-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(
    270deg,
    rgba(84, 168, 255, 1),
    rgba(32, 224, 255, 1)
  );
  box-shadow: 0px 0px 10px 4px rgba(59, 195, 255, 0.2);
  text-align: center;
  margin: 0 auto;
  height: 25px;
  line-height: 25px;
  display: block;
  font-size: 13px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.mod_hotgame li .down-pc {
  color: #fff;
  background: -webkit-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -o-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -mos-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: -moz-linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(left bottom, #20e0ff, #54a8ff);
  background: linear-gradient(
    270deg,
    rgba(84, 168, 255, 1),
    rgba(32, 224, 255, 1)
  );
  box-shadow: 0px 0px 10px 4px rgba(59, 195, 255, 0.2);
  text-align: center;
  margin: 0 auto;
  height: 25px;
  line-height: 25px;
  display: block;
  font-size: 13px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}

.mod_hotgame li {
  float: left;
  width: 16%;
  margin: 10px 4.5% 0;
}

.mod_hotgame li p {
  font-size: 14px;
  width: 100%;
  height: 32px;
  margin: 0 0;
  line-height: 32px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/**/

.xfb-zz-content {
  width: 100%;
  position: fixed;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.5);
}

.xfb-zz-content-box {
  width: 200px;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 5px;
  padding: 15px 15px;
  box-sizing: border-box;
  transform: translate(-50%, -50%);
  background-color: #fff;
}

.xfb-zz-content-box .close {
  width: 25px;
  width: 50px;
  position: absolute;
  top: -35px;
  right: 5px;
  border-radius: 15px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #999;
  font-size: 14px;
  line-height: 26px;
  color: #000000;
}

.xfb-zz-content-box .img-box {
  width: 100%;
  position: relative;
}

.xfb-zz-content-box .img-box img {
  width: 100%;
}

.xfb-zz-content-box p {
  width: 100%;
  margin: 15px 0 0 0;
  font-size: 14px;
  color: #000000;
  text-align: center;
}
.seahotid-ios {
  width: 100%;
}
.seahotid-anz {
  width: 100%;
}
.seahotid-pc {
  width: 100%;
}
.gg-img {
  width: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
}
.gg-img img {
  width: 100%;
  object-fit: cover;
  border-radius: 4px;
  vertical-align: middle;
}

.llt {
  position: absolute;
  left: 28%;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue